var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-editor"},[_c('div',{ref:"editor",staticClass:"rich-editor__container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }